import React, { ReactNode } from 'react'
import {
  ButtonLight,
  Menu,
  MenuButton,
  MenuList
} from 'front-end/src/components'
import type { MenuProps } from 'front-end/src/components/common/menu/Menu'
import { Trans } from '@lingui/macro'
import { IconSelectArrowDown } from 'front-end/src/components/common/icon/IconSelectArrowDown'

type MenuBulkActionProps = MenuProps & {
  isDisabled: boolean
  children: ReactNode
  dataTest?: string
}

export const MenuBulkAction = ({
  isDisabled,
  children,
  dataTest = 'MenuBulkAction',
  ...rest
}: MenuBulkActionProps) => {
  return (
    <Menu {...rest}>
      <MenuButton
        disabled={isDisabled}
        as={ButtonLight}
        rightIcon={<IconSelectArrowDown />}
      >
        <Trans>Bulk action</Trans>
      </MenuButton>
      <MenuList data-test={dataTest} bgColor="white">
        {children}
      </MenuList>
    </Menu>
  )
}
